export default {
  // 七牛上传地址
  QI_NIU_URL: 'https://upload.qiniup.com',
  // 七牛文件域名
  QI_NIU_DOMAIN: 'https://oss.zhihanyun.com/',
  // API 模块路径
  API_MODULE_PATH: {
    // 运动模块
    EXERCISE: '/api-exercise',
    // 园所模块API路径
    ORGANIZE: '/api-manager',
    // 学员模块API路径
    STUDENT: '/api-manager',
    // 健康模块API路径
    HEALTH: '/api-health',
    // 未待办列表API路径
    MESSAGE: '/api-message',
    // 居家课程
    HOME: '/api-home',
    // 课程管理
    TEACHING: '/api-teaching',
    // 评估模块管理
    EVALUATION: '/api-evaluation/admin'
  }
}
